// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"4375a9f2","591":"e9e55f25","658":"26b7437b","699":"3cfb52f6"}[chunkId] + ".chunk.js";
};